/**
 * Base URL for the Met's main marketing site (metopera.org).
 *
 * The On Demand app links out to the marketing site from the header nav, the
 * footer, login, registration, ticketing CTAs and the marketing/account
 * dropdown. Those hosts used to be hardcoded, which meant the QA build and the
 * production build could not point at different marketing hosts without
 * editing source.
 *
 * Env-gated via REACT_APP_MET_MAIN_SITE_URL:
 *   .env.qa          sets it to the Met's QA marketing host
 *   .env.production  leaves it unset, so production falls back to the live host
 *   .env.stage       leaves it unset, same fallback
 *
 * This is deliberately a THIRD variable, separate from:
 *   REACT_APP_METOPERA_BASE_URL   Tessitura purchase flow (see Player.tsx)
 *   REACT_APP_REPORTING_BASE_URL  play telemetry (see getReportingEndpoint)
 * Those two address different services and must stay independently switchable.
 */
export const MET_MAIN_SITE_URL =
  process.env.REACT_APP_MET_MAIN_SITE_URL || "https://www.metopera.org";

/**
 * Build a main-site URL. The path is concatenated verbatim, so callers keep
 * full control of trailing slashes, casing and fragments. Pass a leading slash.
 */
export const metUrl = (path: string): string => `${MET_MAIN_SITE_URL}${path}`;
